import { CreatedAt, Timezone, UpdatedAt } from './common.model';

export interface Mentor {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    image: string;
    followers: number;
    followings: number;
    media: number;
    page: string;
    social_media: SocialMedia[];
}

export interface SocialMedia {
    id: number;
    title: string;
    icon: string;
    username: string;
    url?: string;
    link?: string;
}

export interface Ticket {
    answers: Answers[];
    id: number;
    uid: string;
    title: string;
    description: string;
    status: 'closed' | 'waiting' | 'answered' | 'pending';
    status_fa: string;
    status_changed_at: StatusChangedAt;
    attachment: string;
    created_at: CreatedAt;
    updated_at: UpdatedAt;
    category: {
        id: number;
        name: string;
        description: string;
        image: string;
    };
}

export type Operator = {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    image?: string;
};

export interface Answers {
    items: AnswerItem[];
    date: {
        year: number;
        month: number;
        month_name: string;
        day: number;
        dayOfWeek: string;
        h: string;
        m: string;
        s: string;
    };
}

export interface AnswerItem {
    id: number;
    title?: string;
    description: string;
    attachment: string | null;
    mime_type?: string | null;
    operator: Operator | null;
    created_at: CreatedAt | null;
    updated_at: UpdatedAt | null;
}

export interface StatusChangedAt {
    year: number;
    month: number;
    day: number;
    dayOfWeek: number;
    dayOfYear: number;
    hour: number;
    minute: number;
    second: number;
    micro: number;
    timestamp: number;
    formatted: string;
    timezone: Timezone;
}

export enum TicketStatus {
    Closed = 'closed',
    Answered = 'answered',
    Waiting = 'waiting',
    Pending = 'pending'
}

export const TicketStatusLabels: Record<TicketStatus, string> = {
    [TicketStatus.Closed]: 'بسته شده',
    [TicketStatus.Answered]: 'پاسخ داده شده',
    [TicketStatus.Waiting]: 'در انتظار پاسخ',
    [TicketStatus.Pending]: 'در حال پیگیری'
};

export interface MentorsResponse {
    data: Mentor;
}

export interface TicketsResponse {
    data: Ticket[];
}

export type TicketCategoriesResponse = TicketCategory[];

export interface TicketCategory {
    id: number;
    name: string;
    description: string;
    image: string;
}

export type TicketSingleResponse = Ticket;

